import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import StatusStrip from '../../components/vinExtraction/StatusStrip';
import SettingsEditModal from '../../components/vinExtraction/SettingsEditModal';
import VinLoadError from '../../components/vinExtraction/VinLoadError';
import SettingsSkeleton from './SettingsSkeleton';

/** The status strip and its edit modal once the settings are read; a skeleton before, an error with Retry instead. */
const SettingsArea = ({ load, readOnly, retry, adoptSettings, loadSettings }) => {
    const { t } = useTranslation('vinExtraction');
    const [editOpen, setEditOpen] = useState(false);

    if (load.status === 'loading') return <SettingsSkeleton />;
    if (load.status !== 'ready') {
        return (
            <VinLoadError
                status={load.status}
                error={load.error}
                message={t('loadFailed')}
                invalidDescription={t('invalidResponse')}
                onRetry={retry}
            />
        );
    }

    return (
        <>
            <StatusStrip settings={load.settings} readOnly={readOnly} onEdit={() => setEditOpen(true)} />
            <SettingsEditModal
                open={editOpen && !readOnly}
                settings={load.settings}
                readOnly={readOnly}
                onClose={() => setEditOpen(false)}
                onSettingsChange={adoptSettings}
                onReload={loadSettings}
            />
        </>
    );
};

export default SettingsArea;
